import _ from "lodash";

export const toProperCase = (text) => _.startCase(_.toLower(text));

export const alphabeticalSortCompareFunction = (pre, post, order) => {
  // order is asc or desc
  const capitalOrder = order.toUpperCase();
  const orderOperator = capitalOrder === "ASC" ? 1 : -1;
  const capitalPre = pre.toUpperCase();
  const capitalPost = post.toUpperCase();
    if(capitalPre < capitalPost) {
      return -1 * orderOperator;
    }
    if(capitalPre > capitalPost){
      return 1 * orderOperator;
    }
    return 0
}